import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { setFilter } from "../../features/Job/jobSlice";

export default function Sidebar() {
  const dispatch = useDispatch();

  const handleFilter = (e, value) => {
    e.preventDefault();
    dispatch(setFilter(value));
  };

  return (
    <div className="sidebar">
      <nav>
        <ul className="space-y-4">
          <li>
            <a
              onClick={(e) => handleFilter(e, "")}
              href="/jobs"
              className="main-menu menu-active"
              id="lws-alljobs-menu"
            >
              <i className="fa-solid fa-briefcase" />
              <span> All Available Jobs</span>
            </a>
            <ul className="space-y-6 lg:space-y-2 ">
              <li onClick={(e) => handleFilter(e, "Internship")}>
                <a
                  className="sub-menu"
                  href="/jobs/internship"
                  id="lws-internship-menu"
                >
                  <i className="fa-solid fa-stop !text-[#FF5757]" />
                  Internship
                </a>
              </li>
              <li onClick={(e) => handleFilter(e, "Full Time")}>
                <a
                  className="sub-menu"
                  href="/jobs/fulltime"
                  id="lws-fulltime-menu"
                >
                  <i className="fa-solid fa-stop !text-[#FF8A00]" />
                  Full Time
                </a>
              </li>
              <li onClick={(e) => handleFilter(e, "Remote")}>
                <a
                  className="sub-menu"
                  href="/jobs/remote"
                  id="lws-remote-menu"
                >
                  <i className="fa-solid fa-stop !text-[#56E5C4]" />
                  Remote
                </a>
              </li>
            </ul>
          </li>
          <li>
            <Link to="/Create" className="main-menu" id="lws-addJob-menu">
              <i className="fa-solid fa-file-circle-plus" />
              <span>Add NewJob</span>
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  );
}
